import { render } from "./KotBotMessageComponent.vue?vue&type=template&id=f0f74bf0"
import script from "./KotBotMessageComponent.vue?vue&type=script&lang=js"
export * from "./KotBotMessageComponent.vue?vue&type=script&lang=js"

import "./KotBotMessageComponent.vue?vue&type=style&index=0&id=f0f74bf0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__